/* eslint-disable react/style-prop-object */
import React, { useState, useEffect } from "react";
import { Select } from "antd";
import {
	useGetAllNotificationsQuery,
	useGetNotificationsByDeviceIdQuery,
} from "../../../../../../../Redux/service/Notifications/Notifications";
import {
	useAddPermissionMutation,
	useDeletePermissionMutation,
} from "../../../../../../../Redux/service/Permissions/Permissions";
import { toast } from "react-toastify";
import trans from "../../../../../../../utils";

const SetNotification = ({ title, device }) => {
	const [selectedNotification, setSelectedNotification] = useState([]);
	const [loading, setLoading] = useState(false);

	const { data: allNotifications = [] } = useGetAllNotificationsQuery();
	const { data: initialSelected = [], refetch: refetchSelected } =
		useGetNotificationsByDeviceIdQuery(device?.id, {
			skip: !device?.id,
		});

	const [addPermission] = useAddPermissionMutation();
	const [deletePermission] = useDeletePermissionMutation();

	// Sync local state with API data
	useEffect(() => {
		if (initialSelected) {
			setSelectedNotification(initialSelected.map((n) => n?.id));
		}
	}, [initialSelected]);

	const handleChange = async (newValues) => {
		const added = newValues.filter((id) => !selectedNotification.includes(id));
		const removed = selectedNotification.filter(
			(id) => !newValues.includes(id)
		);

		const toastConfig = {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar",
		};

		setLoading(true);

		// Handle Additions
		for (const id of added) {
			try {
				await addPermission({
					deviceId: device?.id,
					notificationId: id,
				}).unwrap();
				toast.success(
					trans("New Notification is linked to the device"),
					toastConfig
				);
			} catch (error) {
				toast.error(
					trans(
						"Error linking the Notification to device, please try again later"
					),
					toastConfig
				);
			}
		}

		// Handle Removals
		for (const id of removed) {
			try {
				await deletePermission({
					deviceId: device?.id,
					notificationId: id,
				}).unwrap();
				toast.success(trans("Notification unlinked successfully"), toastConfig);
			} catch (error) {
				toast.error(
					trans(
						"Error unlinking the Notification from device, please try again later"
					),
					toastConfig
				);
			}
		}

		// Refresh data and stop loading
		await refetchSelected();
		setLoading(false);
	};

	if (title !== "set notification") return null;

	return (
		<div className="pb-3">
			<Select
				mode="multiple"
				loading={loading}
				disabled={loading}
				style={{ width: "100%", marginTop: 12 }}
				placeholder={trans("Select Notifications")}
				value={selectedNotification}
				onChange={handleChange}
				options={allNotifications.map((noti) => ({
					value: noti?.id,
					label: noti?.type,
				}))}
				filterOption={(input, option) =>
					option.label.toLowerCase().includes(input.toLowerCase())
				}
			/>
		</div>
	);
};

export default SetNotification;
